import FlatList from 'flatlist-react/lib';
import styles from '../css/cart.module.css';
import { BsTrash } from 'react-icons/bs';
import { BiMinus, BiPlus, BiEdit } from 'react-icons/bi';
import { HiOutlineDocumentText } from 'react-icons/hi2';
import { RenderComplements } from './renderComplements';
import { formatValue } from '../../../scripts/formatValue';
import { useAppRouter } from '../../../hooks/useAppRouter';

const no_image_vector = require('../../../assets/marca-dagua-sofchef.png');

export const RenderProducts = ({ item, index, deleteAlert, changeAmount, companyData }) => {
    const navigate = useAppRouter(); // Hook para navegação

    let price = formatValue(item.total_price);
    let basePrice = formatValue(item.total_price / item.amount);

    // SAVE PRODUCT COMPLEMENTS LIST TO RENDER
    const complements = item.complements;

    // Função para editar o produto
    const handleEditProduct = () => {
        // Prepara os dados no formato que a tela de produto espera
        const editData = {
            productId: item.id,
            isEditing: true,
            cartIndex: index,
            currentQuantity: item.amount,
            selectedComplements: complements.map(complement => ({
                id: complement.id,
                name: complement.complement, // Note: na tela de produto é 'name', não 'complement'
                price: complement.price,
                count: complement.quantity, // Note: na tela de produto é 'count', não 'quantity'
                type: complement.type,
                collectionId: complement.collectionId
            })),
            observation: item.observation || '',
            currentPrice: item.total_price,
            basePrice: item.base_price
        };



        // Navega para a tela do produto com os dados de edição
        navigate(`product/${item.id}`, {
            state: editData
        });
    };

    return (
        <li key={index}>
            <div className={styles.productComponent}>
                <div className={styles.prodContainer}>
                    <div className={styles.productImageTextArea}>
                        <img className={styles.imgProductCart} src={item.image || no_image_vector} />

                        <div className={styles.productInformations}>
                            <div className={styles.productNameRow}>
                                <p className={styles.textProduct}>{item.name}</p>

                                <div className={styles.amountButtonsContainer}>
                                    {item.amount === 1 ? (
                                        <button className={styles.excludeProdButton} onClick={() => deleteAlert({ show: true, index })}>
                                            <BsTrash size={13} color="#F63F27" />
                                        </button>

                                    ) : (
                                        <button className={styles.btnQtd} style={{ backgroundColor: companyData.background_color }} onClick={() => changeAmount({ type: 'minus', index: index })}>
                                            <BiMinus size={14} color={companyData.text_color} />
                                        </button>
                                    )}

                                    <p className={styles.prodQtdArea}>{item.amount}</p>

                                    <button className={styles.btnQtd} style={{ backgroundColor: companyData.background_color }} onClick={() => changeAmount({ type: 'add', index: index })}>
                                        <BiPlus size={14} color={companyData.text_color} />
                                    </button>
                                </div>
                            </div>

                            <div className={styles.priceNameRow}>
                                <p className={styles.textPrice} style={{ color: companyData.background_color }}>{price}</p>

                                <button
                                    className={styles.editButton}
                                    onClick={handleEditProduct}
                                    title="Editar produto"
                                >
                                    <BiEdit size={14} color={'#fff'} />
                                </button>
                            </div>


                            {item.amount > 1 && (
                                <p className={styles.textUnitPrice}>
                                    {basePrice} x {item.amount}
                                </p>
                            )}
                        </div>

                    </div>

                    <div className={styles.openedProductsArea}>
                        {complements.length > 0 && (
                            <div className={styles.complementsListArea}>
                                {complements.map((item, index) => (
                                    <RenderComplements item={item}/>
                                ))}
                            </div>
                        )}

                        {item.observation && (
                            <div className={styles.observationArea}>
                                <p className={styles.labelObservation}>
                                    <HiOutlineDocumentText size={13} />
                                    Observações
                                </p>
                                <p className={styles.observationText}>
                                    {item.observation}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </li>
    );
};
